export default __webpack_public_path__ + "static/media/background-2.f0b429f9.jpg";